import React, { Component } from 'react';
import './App.css';
import Nav from './components/nav.js';
import Pic from './components/pic.js';
import Tbody from './components/textbody.js';
import Buttonwrapper from './components/buttonwrapper.js';
import $ from 'jquery';


var interval



class App extends Component {
  componentDidMount(){
    /*let blimit = $('.endstop').offset().top - document.getElementById('campfire').clientHeight;
    $(window).resize(()=>{
      blimit = 1038;
      $(window).scroll();
      setTimeout(()=>{blimit = $('.endstop').offset().top - document.getElementById('campfire').clientHeight;$(window).scroll()},250);
    })
    $(window).scroll(()=>{
        if (document.documentElement.clientWidth<900){
          return
        }
        let h = $(document).height();
        let z = h>3000?.06:0;
        let sc = $(window).scrollTop()+$('.banner').height()

        $('#campfire').css('top',Math.min(sc*(.9+z)-100,blimit*(1.2))+'px');
        //$('#campfire').css('top',1500-sc*(.9+z)+'px');
        $('#BG1').css('top',Math.min(sc*(.75+z),blimit)+'px');
        $('#BG2').css('top',Math.min(sc*.5,650)+'px');
    });
    $(document).ready(()=>{window.scroll()})*/
    let blimit = $('.endstop').offset().top - document.getElementById('campfire').clientHeight;
    $(window).resize(()=>{
      blimit = 1038;
      $(window).scroll();
      setTimeout(()=>{blimit = $('.endstop').offset().top - document.getElementById('campfire').clientHeight;$(window).scroll()},250);
    })
    function scroll(){
      if (document.documentElement.clientWidth<900){
        return
      }
      let h = $(document).height();
      let z = h>3000?.06:0;
      let sc = $(window).scrollTop()+$('.banner').height()

      $('#campfire').css('top',Math.min(sc*(.9+z),blimit*(1.2))+'px');
      //$('#campfire').css('top',1500-sc*(.9+z)+'px');
      $('#BG1').css('top',Math.min(sc*(.75+z),blimit)+'px');
      $('#BG2').css('top',Math.min(sc*.5,650)+'px');
    }
    clearInterval(interval);
    interval = setInterval(scroll,2);
    $(document).ready(()=>{scroll();console.log("ready")})
  }
  render() {
    return (
      <div className="App">
        <div id='campfire' ></div>
        <div id='BG1'  />
        <div id='BG2'  />
        <div id='BG3'/>
        <div className='banner'>
          <Buttonwrapper/>
          <Pic/>
          <Nav/>
        </div>
        <Tbody/>
      </div>
    );
  }
}



export default App;



// WEBPACK FOOTER //
// ./src/App.js